import RestrictedAppointmentDatesTable from "./RestrictedAppointmentDatesTable";

const RestrictedAppointmentDates = () => {
  
    return (    
      <RestrictedAppointmentDatesTable key={0}/>
    );
}
export {RestrictedAppointmentDates}
